import { render, staticRenderFns } from "./year_turnover.vue?vue&type=template&id=37ea3ce8&scoped=true"
import script from "./year_turnover.vue?vue&type=script&lang=js"
export * from "./year_turnover.vue?vue&type=script&lang=js"
import style0 from "./year_turnover.vue?vue&type=style&index=0&id=37ea3ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ea3ce8",
  null
  
)

export default component.exports